import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import { useMessagesStore } from '@/stores/messages'

// Tracks the in-flight request so concurrent callers share one HTTP request
let _pendingFetch = null

export const useCurrentUserStore = defineStore('currentUser',{
  state: () => ({
    currentUser: {
      id: null,
      name: '',
      first_name: '',
      last_name: '',
      email: '',
      ext: null,
      remote_phone: '',
      byline: {
        id: null,
        print_content: '',
        web_content: '',
        attribution: ''
      },
      role_is_limited: true,
      role_is_stringer: false,
      role_name: null,
      can_set_squeue: false,
      can_change_ownership: false,
      can_access_google_picker: false,
      can_view_issue_pages: false,
      can_view_stories: false,
      can_view_media: false,
      can_view_issues: false,
      can_view_locations: false,
      can_access_admin: false,
      can_access_dev: false,
      show_advert_fields: false,
      stories_visible_columns: [],
      stories_always_shown_columns: [],
      local_file_path: '',
      assignment_notifications: false,
      default_publication_id: null,
      default_story_saved_search_id: null,
      editable_story_fields: [],
    },
    fetchInitiated: false
  }),

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/current_user')
        .then(({ data: { user } }) => {
          this.currentUser = user
          return user
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
          throw err
        })
    },

    async fetchOnce() {
      if (_pendingFetch) return _pendingFetch
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    },

    async fetchSilently() {
      if (this.fetchInitiated) return _pendingFetch

      this.fetchInitiated = true
      _pendingFetch = httpClient.get('/api/internal/current_user')
        .then(({ data: { user } }) => {
          this.currentUser = user
        })
        .catch(() => {
          // User is not authenticated — nav renders in minimal state
        })
        .finally(() => {
          _pendingFetch = null
        })
      return _pendingFetch
    },

    async update(params) {
      return httpClient.patch('/api/internal/current_user', {
          user: params
        })
        .then(({ data: { user, message }}) => {
          this.currentUser = user
          useMessagesStore().addNotice(message)
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    },
  },
})
